export class ReportState {
    Id: number;
    Code: string;
    Name: string;

    constructor(model?: ReportState) {
        if (model) {
            this.Id = model.Id;
            this.Code = model.Code;
            this.Name = model.Name;
        } else {
            this.Id = null;
            this.Code = null;
            this.Name = null;
        }
    }
}
